import { Formik } from "formik";
import * as React from "react";
import * as Yup from "yup";
import { hrStore } from "../../../stores/HrStore";
import { IPostApplicationStateTransitionPayload } from "../../../types/models";
import { TransferMessageForm } from "./TransferMessageForm";
import { t } from "../../../i18n/util";
import moment from "moment";
import { ErrorMessagesList } from "../../ui/Primitives";

type Props = {
    onSubmit: (model: IPostApplicationStateTransitionPayload) => void;
    onBack: (model: IPostApplicationStateTransitionPayload) => void;
    cancel: boolean;
    firstName: string;
    allowScheduledEmail?: boolean;
};

export const KanbanTransferMessageDialog = ({ onSubmit, onBack, cancel, firstName, allowScheduledEmail }: Props) => {
    const validation = {
        language: Yup.string(),
        template: Yup.string(),
        message: Yup.string(),
        noMessage: Yup.boolean(),
        scheduledEmail: Yup.boolean(),
        scheduledEmailDate: Yup.date()
            .nullable()
            .typeError(t("error.date"))
            .when("scheduledEmail", {
                is: true,
                then: Yup.date().required(t("error.date")).min(moment().toDate(), t("error.date"))
            })
    };

    return (
        <Formik
            initialValues={hrStore.currentDialogForm}
            onSubmit={(model: IPostApplicationStateTransitionPayload) => {
                onSubmit(model);
            }}
            validationSchema={Yup.object().shape(validation)}
            validateOnChange
            validateOnBlur
        >
            {({ values, errors, touched, setFieldValue }) => (
                <>
                    <TransferMessageForm
                        values={values}
                        setFieldValue={setFieldValue}
                        cancel={cancel}
                        onBack={onBack}
                        firstName={firstName}
                        allowScheduledEmail={allowScheduledEmail}
                        errors={errors}
                        touched={touched}
                    />
                </>
            )}
        </Formik>
    );
};
